import useDeleteReport from './useDeleteReport';

export default useDeleteReport;
